import { useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultMultiPay, getWorkflowSteps } from "compid/workflows/MultiPay";

import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import LeftColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/LeftColumnContainer";
import RightColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/RightColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import SchedulePaymentWidget from './components/SchedulePaymentWidget';
import SchedulePaymentsMultipay from "./components/SchedulePaymentsMultipay";

export default function SchedulePaymentsPage(props) {
  // Initalize the workflow step
  const workflowStep = useWorkflowStep(getDefaultMultiPay, getWorkflowSteps);
  const items = workflowStep.read("items");
  // onUpdate :: Update the specific multipay item in the state array
  const onUpdate = (prop, value, multipay) => {
    const updatedItems = items.map(item => {
      if(item.bill.id === multipay.bill.id) {
        item[prop] = value;
      }

      return item;
    }, []);
    // Update the workflow step state with the new changes
    workflowStep.update([ "items" ], updatedItems);
  };
  // onRemove :: remove the passed multipay item from the state and update
  const onRemove = multipayItem => {
    const updatedItems = items.filter(item => item.bill.id !== multipayItem.bill.id, []);
    workflowStep.update([ "items" ], updatedItems);
  };
  // Initalize a SchedulePaymentWidget component for each item in state
  const paymentItems = items.map(item => {
    const onChange = (prop, value) => onUpdate(prop, value, item);

    return (
      <SchedulePaymentWidget
        key={ `SchedulePayment_${ item.bill.id }` }
        multipay={ item }
        onChange={ onChange }
        onRemove={ onRemove } />
    );
  }, []);

  return(
    <PageView className="schedule-payment-page">
      <p className="page-sub-header semi-bold-text">SCHEDULE PAYMENTS</p>
      
      <PageLayoutContainer>
        <LeftColumnContainer>
          { paymentItems }
        </LeftColumnContainer>
        <RightColumnContainer>
          <SchedulePaymentsMultipay items={ items } />
        </RightColumnContainer>
      </PageLayoutContainer>
    </PageView>
  );
 }